import { HttpLink } from '@apollo/client/link/http/index.js'

export const httpLink = ({ uri, customFetch = fetch }: { uri: string; customFetch?: typeof fetch }) =>
  new HttpLink({
    uri,
    fetch: customFetch,
    credentials: 'include',
  })
